export const fieldNamePrefix = "field";

export const maximumDecimalPlaces = 6;

export const maximumUndoLevels = 10;
